module.exports = __webpack_public_path__ + "static/img/logo-hyb.0f293ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/channel/img/logo-hyb.png
// module id = D79Q
// module chunks = 1